/**
 * Curated icon set for license-type display — a fixed, verified-to-exist subset of
 * @fluentui/react-icons rather than free-text icon names, so admin config can't reference an
 * icon that doesn't exist/isn't bundled.
 */
import type { FluentIcon } from '@fluentui/react-icons'
import {
  CertificateRegular,
  MailRegular,
  VideoRegular,
  DocumentTextRegular,
  TableRegular,
  ChatRegular,
  WhiteboardRegular,
  PeopleRegular,
  ShieldRegular,
  AppsRegular,
  CloudArrowUpRegular,
  NotebookRegular,
  ClipboardTaskRegular,
  CameraRegular,
  PersonBoardRegular,
  SettingsRegular,
  CalendarLtrRegular,
  PresenterRegular,
  BriefcaseRegular,
  RibbonRegular,
  BoxRegular,
} from '@fluentui/react-icons'

export const LICENSE_ICONS: Record<string, FluentIcon> = {
  certificate: CertificateRegular,
  mail: MailRegular,
  video: VideoRegular,
  documentText: DocumentTextRegular,
  table: TableRegular,
  chat: ChatRegular,
  whiteboard: WhiteboardRegular,
  people: PeopleRegular,
  shield: ShieldRegular,
  apps: AppsRegular,
  cloud: CloudArrowUpRegular,
  notebook: NotebookRegular,
  clipboardTask: ClipboardTaskRegular,
  camera: CameraRegular,
  personBoard: PersonBoardRegular,
  settings: SettingsRegular,
  calendar: CalendarLtrRegular,
  presenter: PresenterRegular,
  briefcase: BriefcaseRegular,
  ribbon: RibbonRegular,
  box: BoxRegular,
}

export const DEFAULT_ICON_KEY = 'certificate'

export function getLicenseIcon(iconKey?: string): FluentIcon {
  return LICENSE_ICONS[iconKey ?? DEFAULT_ICON_KEY] ?? LICENSE_ICONS[DEFAULT_ICON_KEY]
}
